export const environment = {
  baseURL: 'https://api-sdgi-homol.canvi.com.br',
};

//https://choice-haddock-concise.ngrok-free.app

// https://api-sdgi-homol.canvi.com.br

//http://10.255.251.21:3000

//http://172.25.26.31:3000
